jQuery(function($) {
    function incrementVideoViews() {
        $.ajax({
            url: wemake.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'wemake_increment_video_views'
            },
            beforeSend: function () {
                console.log('Sending view increment...');
            },
            success: function (data) {
                if (data.success) {
                    console.log('New total views:', data.data.views);
                } else {
                    console.warn('Failed to increment views.');
                }
            },
            error: function (xhr, status, error) {
                console.error('Error:', error);
            }
        });
    }

    $('video').each(function() {
        var hasCounted = false;

        $(this).on('play', function() {
            var src = $(this).attr('src');

            // only increment once per video element
            if (!hasCounted && src === "https://player.vimeo.com/progressive_redirect/playback/1098520656/rendition/1080p/file.mp4?loc=external&signature=ba578cdb94f55a9a3e471b80a76e34c090894116e8be7595888eab25414f89b2") {
                incrementVideoViews();
                hasCounted = true; // prevent further increments
            }
        });
    });

});
